<script>
export default {
  props: {
    phone: {
      type: String,
      required: false,
      default: ""
    },
    text: {
      type: String,
      required: false,
      default: ""
    },
    label: {
      type: String,
      required: true
    }
  },

  methods: {
    url() {
      let url = new URL("https://api.whatsapp.com/send");

      if (this.phone.length) url.searchParams.append("phone", this.phone);
      if (this.text.length) url.searchParams.append("text", this.text);

      return url;
    }
  }
};
</script>

<template>
  <a :href="url()" class="btn bg-green wpp" target="_blank" rel="noopener noreferrer">
    {{label}}
    <img src="\static\whatsapp_logo.svg" class="ml-10" />
  </a>
</template>

<style scoped>
.wpp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.wpp {
  flex-direction: column-reverse;
}

.wpp img {
  height: 18px;
  margin-bottom: 10px;
}

@media (min-width: 668px) {
  .wpp {
    flex-direction: row;
  }

  .wpp img {
    height: 18px;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/WhatsAppButton.vue